import * as Globals from './globals';
import {buildingGroup, clearStates, furnitureGroup, overwriteGroup} from "./main";
import {reconstructUserDataRecursive} from "./projectManager";
import {clearGroup, render} from "./sceneManager";
import {generateMeasurements} from "./models/measurements/measurementGeneration";
import {createRooms} from "./models/rooms/roomGeneration";
import {reconstructUISettings} from "./utils/dialogUtils";
import {recalculateBuildingParameters} from "./calculators/buildingParameters/parameterCalculator";
import {updateWallSnapAxis} from "./models/walls/wallGeneration";

export const TransactionManager = {
    undoStates: [], redoStates: [], currentState: [], init: function () {
        this.undoStates = [];
        this.currentState = [];
        this.redoStates = [];
        this.inTransaction = false;
    }, startTransaction: function () {
        //Nur transaction starten, wenn noch keine gestartet
        if (this.inTransaction) {
            return;
        }

        this.inTransaction = true;
        this.currentState = {
            buildingGroup: buildingGroup.clone(),
            furnitureGroup: furnitureGroup.children.length > 0 ? furnitureGroup.clone() : null
        }; //Aktuellen Stand der Szene zwischenspeichern
        render();
    }, abortTransaction: function () {
        this.currentState = [];
        this.inTransaction = false;
        reconstructUserDataRecursive(buildingGroup);
        reconstructUserDataRecursive(furnitureGroup);
        render();
    },
    stopTransaction: function () {
        //Nur versuchen zu stoppen, wenn auch eine Transaction läuft
        if (!this.inTransaction) {
            return;
        }

        //Aktuellen State als letzten Undo State festlegen
        this.undoStates.push(this.currentState);
        this.redoStates = []; //Redo steps löschen > Bei Veränderung der Szene werden Redo steps ungültig
        this.inTransaction = false; //Nicht mehr in transaction
        render();
    }, undo: function () {
        if (this.undoStates.length === 0) {
            return;
        }
        this.redoStates.push({
            buildingGroup: buildingGroup.clone(),
            furnitureGroup: furnitureGroup.children.length > 0 ? furnitureGroup.clone() : null
        }); //Aktuellen Stand der Szene zwischenspeichern);
        overwriteGroup(buildingGroup, this.undoStates[this.undoStates.length - 1].buildingGroup);
        overwriteGroup(furnitureGroup, this.undoStates[this.undoStates.length - 1].furnitureGroup);
        clearGroup(this.undoStates[this.undoStates.length - 1]);
        this.undoStates.splice(this.undoStates.length - 1, 1);
        this.limitSteps();
        adjustScene();
    }, redo: function () {
        if (this.redoStates.length === 0) {
            return;
        }
        this.undoStates.push({
            buildingGroup: buildingGroup.clone(),
            furnitureGroup: furnitureGroup.children.length > 0 ? furnitureGroup.clone() : null
        });
        overwriteGroup(buildingGroup, this.redoStates[this.redoStates.length - 1].buildingGroup);
        overwriteGroup(furnitureGroup, this.redoStates[this.redoStates.length - 1].furnitureGroup);
        clearGroup(this.redoStates[this.redoStates.length - 1]);
        this.redoStates.splice(this.redoStates.length - 1, 1);
        this.limitSteps();
        adjustScene();
    }, limitSteps() {
        while (this.undoStates.length > Globals.undoLimit) {
            this.undoStates.splice(0, 1);
        }

        while (this.redoStates.length > Globals.undoLimit + 1) {
            this.redoStates.splice(0, 1);
        }
    }
};

function adjustScene() {
    clearStates();
    reconstructUserDataRecursive(buildingGroup);
    reconstructUserDataRecursive(furnitureGroup);
    reconstructUISettings();
    generateMeasurements().then();
    recalculateBuildingParameters().then();
    createRooms();
    updateWallSnapAxis();
    render();
}
